import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Colors, Sizes, Typography } from "../../styles";
import Context from "./Context";
import MobileFiltersModal from "./MobileFiltersModal";
import FilterCategory from "./FilterCategory";

const FiltersContent = ({
	careerFilters,
	selectedFilters,
	handleSelectFilter,
	clearAllFilters,
}) => (
	<>
		<h4>Refine Your Search</h4>
		<FiltersWrapper>
			<FilterCategory
				careerFilters={careerFilters}
				selectedFilters={selectedFilters}
				handleSelectFilter={handleSelectFilter}
			/>
		</FiltersWrapper>
		{selectedFilters.length > 0 && (
			<ClearFiltersButton onClick={clearAllFilters}>
				Clear Filters
			</ClearFiltersButton>
		)}
	</>
);

const Filters = () => {
	const {
		data: { selectedFilters, careerFilters },
		actions: { handleSelectFilter, clearAllFilters },
		modalData: { isMediumOrLargeScreen, isFiltersMobileModalOpen },
		modalActions: { openModal, closeModal },
	} = useContext(Context);

	// conditional rendering based on screen size
	return isMediumOrLargeScreen ? (
		<FiltersContainer id="filters">
			<FiltersContent
				careerFilters={careerFilters}
				selectedFilters={selectedFilters}
				handleSelectFilter={handleSelectFilter}
				clearAllFilters={clearAllFilters}
			/>
		</FiltersContainer>
	) : (
		<>
			{isFiltersMobileModalOpen && (
				<MobileFiltersModal
					careerFilters={careerFilters}
					selectedFilters={selectedFilters}
					handleSelectFilter={handleSelectFilter}
					clearAllFilters={clearAllFilters}
					closeModal={closeModal}
				></MobileFiltersModal>
			)}
			<ButtonContainer>
				<h4>Refine Your Search</h4>
				<button onClick={openModal}>View all filters</button>
			</ButtonContainer>
		</>
	);
};

Filters.propTypes = {
	filters: PropTypes.object,
	onSelectFilter: PropTypes.func,
	selectedFilters: PropTypes.array,
};

FiltersContent.propTypes = {
	selectedFilters: PropTypes.array,
	careerFilters: PropTypes.object,
	handleSelectFilter: PropTypes.func,
	clearAllFilters: PropTypes.func,
};

const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

const ClearFiltersButton = styled.button`
	margin-top: 3rem;
	background: none;
	padding: 0;
	height: fit-content;
	text-align: left;
	color: ${Colors.base.black};
	font-weight: ${Typography.fontWeight.medium};
	text-transform: uppercase;
	font-size: 1rem;
	line-height: 1.6rem;
	letter-spacing: 0.705px;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		margin-top: 0.6rem;
	}

	&:hover {
		font-weight: ${Typography.fontWeight.black};
		box-shadow: none;
	}

	&:focus {
		box-shadow: none;
	}
`;

const FiltersContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		max-height: 90vh;
		overflow-y: auto;
		position: sticky;
		top: 5%;
	}
`;

const FiltersWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4.6rem;
`;

export default Filters;
